import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const H2Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "H2",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.66 19.34h6.66c1.1 0 2-.9 2-2s-.9-2-2-2h-4.67v-2.67h4.68c1.09 0 1.98-.88 1.99-1.97V4.01A2 2 0 0 0 29.33 2h-6.67c-1.1 0-2 .9-2 2s.9 2 2 2h4.67v2.67h-4.67c-1.1 0-1.99.89-1.99 1.99v6.68c0 1.1.9 1.98 1.99 1.98ZM2.67 30c1.1 0 1.99-.89 1.99-1.99V18H14v9.99c0 1.1.9 2 2 2s2-.9 2-2V4.01c0-1.1-.9-2-2-2s-2 .9-2 2V14H4.67V4.01c0-1.1-.9-2-2-2s-2 .9-2 2V28a2 2 0 0 0 1.99 2.01h.01Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 2.29c-.63 0-1.14.51-1.14 1.14v11.43H2.29V3.43a1.14 1.14 0 1 0-2.28 0v25.14a1.14 1.14 0 1 0 2.28 0V17.14h12.57v11.43a1.14 1.14 0 1 0 2.28 0V3.43c0-.63-.51-1.14-1.14-1.14M23.44 17.55c.24-1.83 1.75-2.86 3.55-4.29 1.92-1.53 4.68-3.22 4.68-6.18 0-2.71-2.25-4.8-5.34-4.8-1.94 0-3.75.77-5.21 1.92v2.64h.05c1.61-1.49 3.12-2.34 4.78-2.34 2.19 0 3.38 1.15 3.38 2.71 0 2.02-2.61 3.41-4.24 4.73h.01c-2.49 2.05-4.85 3.82-4.44 7.83h11.2v-2.22z"
      })
    })
  }));
};